<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="38px" viewBox="0 -960 960 960" width="38px" fill="currentColor">
        <path d="M480.24-100q-78.91 0-147.99-29.92-69.09-29.92-120.74-81.54-51.64-51.63-81.58-120.73Q100-401.3 100-480.27q0-78.71 29.92-147.97 29.92-69.27 81.54-120.58 51.63-51.31 120.73-81.25Q401.3-860 480.27-860q78.71 0 147.97 29.92 69.27 29.92 120.58 81.21 51.31 51.29 81.25 120.63Q860-558.9 860-480.24q0 78.91-29.92 147.99-29.92 69.09-81.21 120.61-51.29 51.53-120.63 81.58Q558.9-100 480.24-100Zm.09-50.26q137.46 0 233.44-96.18 95.97-96.18 95.97-233.89 0-137.46-95.85-233.44-95.85-95.97-233.89-95.97-137.38 0-233.56 95.85T150.26-480q0 137.38 96.18 233.56t233.89 96.18ZM480-480Zm-4.05 191.49h50.25v-382.98H394.46v50.26h81.49v332.72Z"/>
    </svg>
</template>

<script>
export default {
    name: 'CounterOneIcon'
}
</script>